import { ACC_KEY, API_URL } from "../config";

export const fetchAddress = async (val: any) => {
    const string = val.toString().replace(/#/, '')

    const myHeaders = new Headers();
    myHeaders.append("Authorization", `Bearer ${ACC_KEY}`);

    const formdata = new FormData();
    formdata.append("term", string);

    const response = await fetch(`${API_URL}v1/address_validator`, {
        method: 'POST',
        headers: myHeaders,
        body: formdata
    })
    return response.json()
}

export const fetchUtility = async (val: number) => {
    if (val !== undefined) {
        const string = val.toString().replace(/#/, '');

        const myHeaders = new Headers();
        myHeaders.append("Authorization", `Bearer ${ACC_KEY}`);
        const formdata = new FormData();
        formdata.append("zipcode", string);

        const response = await fetch(`${API_URL}v1/get_utility`, {
            method: 'POST',
            headers: myHeaders,
            body: formdata
        })
        return response.json()
    }

}